import { api } from "../utils/api";
import type { RestApiKey, CreateApiKey } from "@KassaroAB/shared/types/apiKey";

export const getAllApiKeysApi = async (): Promise<RestApiKey[]> => {
  return api.get(`admin/apiKeys`);
};

export const createApiKeyApi = async (
  data: CreateApiKey,
): Promise<{ apiKey: RestApiKey; plainKey: string }> => {
  return api.post(`admin/apiKeys`, data);
};

export const deactivateApiKeyApi = async (id: string): Promise<void> => {
  return api.put(`admin/apiKeys/${id}/deactivate`, {});
};

export const deleteApiKeyApi = async (id: string): Promise<void> => {
  return api.delete(`admin/apiKeys/${id}`);
};

